import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import associateServices from "../../../services";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import SvgIcon from "../../../components/svg-icon";
import stringHelper from "../../../helpers/string-helper";
import './index.css'
import Loading from "../../../components/loading";
import moment from "moment";
import {LazyLoadImage} from "react-lazy-load-image-component";
import InstrumentIcon from "../../../components/instrument-icon";
import StringHelper from "../../../helpers/string-helper";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import NoData from "../../../components/no-data";

const BonusRequestModal = props => {
    const {t} = useTranslation()
    const {authenticated, selectedWallet} = useSelector(state => state.authenticationReducer)
    const {activeLanguage, configuration} = useSelector(state => state.globalReducer);

    const [theBonus, setTheBonus] = useState({})
    const [baseData, setBaseData] = useState({})
    const [loading, setLoading] = useState(true)
    const [redeeming, setRedeeming] = useState(false)
    const [data, setData] = useState([])
    const [allBonuses, setAllBonuses] = useState([])

    const {handleClose} = props

    useEffect(() => {
        if (activeLanguage?.key && selectedWallet?.code) {
            associateServices.getBonusRequestContent({
                code: selectedWallet.code,
                language: activeLanguage?.key,
            }).then(res => {

                if (Object.keys(res?.data)?.length >= 1) {
                    setAllBonuses(Object.values(res?.data).flat())
                    setBaseData(res?.data)
                }

                setLoading(false)
            })
        }
    }, [selectedWallet?.code, activeLanguage?.key])

    useEffect(() => {
        if (Object.keys(baseData)?.length >= 1) {
            const tabs = ['all', ...Object.keys(baseData || {})];
            setItems(tabs)
            setActiveType('all')
        }
    }, [baseData])


    useEffect(() => {

        if (authenticated) {


            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('bonus-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

            mdl.classList?.add('modal-fade')

            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')

            }
        }
    }, [authenticated])

    const [items, setItems] = useState([])

    const {modalTab} = useSelector(state => state.globalReducer)
    const [activeType, setActiveType] = useState('deposit')

    useEffect(() => {
        if (modalTab)
            setActiveType(modalTab)
    }, [modalTab])


    useEffect(() => {
        setData(activeType === 'all' ? allBonuses : baseData[activeType])
    }, [baseData, activeType])

    const [searchParams, setSearchParams] = useSearchParams()

    const handleActiveType = type => {
        searchParams.set('modal', 'bonus-request')
        searchParams.set('tab', type)
        setSearchParams(searchParams)
    }

    const handleBonusDetail = bonus => {
        setTheBonus(bonus)
    }

    const handleClaim = bonus => {
        setRedeeming(true)

        associateServices.claimBonusRequestContent({id: bonus.id, code: selectedWallet?.code}).then(res => {

            setRedeeming(false)

            if (res?.status !== 200) {

                setData(prevState => prevState?.map(pp => pp.id === bonus.id ? {
                    ...pp,
                    passive: true
                } : pp))

                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)
            }
            return toast(<InformationToast
                icon={'ti-info-circle'}
                title={t(`general.information`)}
                message={t(`api-notifications.${res?.data}`)}
            />)

        })
    }
    useEffect(() => {

        if (theBonus?.image) {


            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('bonus-modal-detail')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

            mdl.classList?.add('modal-fade')

            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')

            }
        }
    }, [theBonus])


    const handleCloseDetail = () => {

        const bdy = document.body
        bdy.classList?.remove('modal-open')

        const mdl = document.getElementById('bonus-modal-detail')
        mdl.classList?.remove('show')

        mdl.style.display = 'none'
        mdl.style.backgroundColor = ''

        mdl.classList?.remove('modal-fade')

        setTheBonus({})

    }

    return (
        <>
            <div
                className="modal fade"
                id="bonus-modal"
                tabIndex={-1}
                onClick={handleClose}
            >
                <div className="modal-dialog modal-dialog-centered bigger" onClick={e => e.stopPropagation()}>
                    <div className="modal-content bigger">
                        <div className="modal__content bigger">
                            <div className="modal__head">
                                <div className="d-flex align-items-center gap-2">
                                    <SvgIcon id={'giftbox'}/>
                                    <h6 className="modal__title">{t('bonus-request.modal-title', 'Request Bonust')}</h6>
                                </div>
                                <button
                                    className="modal__close"
                                    type="button"
                                    onClick={handleClose}
                                >
                                    <SvgIcon id={'x'}/>
                                </button>
                            </div>
                            {
                                items?.length >= 1 &&
                                <ul className="nav nav-tabs tabs-nav tabs-nav--modal">
                                    {
                                        items?.map((ii) => (
                                            <li
                                                onClick={e => handleActiveType(ii)}
                                                className="nav-item" role="presentation"
                                                key={ii}
                                            >
                                                <button
                                                    className={`tabs-nav__btn ${activeType === ii ? 'active' : ''}`}
                                                    type="button"
                                                >

                                                    {t(`bonus-request.${ii}`, StringHelper.formatLabel(ii))}
                                                </button>
                                            </li>
                                        ))
                                    }
                                </ul>
                            }

                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    role="tabpanel"
                                >
                                    <div className="row">
                                        {
                                            loading ? <Loading/> :
                                                !data || data?.length <= 0 ?
                                                    <NoData desc={t('modals.vip.bonus.no-bonus-found')}/> :

                                                    data?.map((promotion, i) => (
                                                        <div className="col-12 col-md-6 col-xxl-3 fade-in"
                                                             key={i}>
                                                            <div className="promo-post promo-post--grid">
                                                                <a
                                                                    onClick={e => handleBonusDetail(promotion)}
                                                                    className="promo-post__cover">
                                                                    <LazyLoadImage
                                                                        height={'100%'}
                                                                        width={'100%'}
                                                                        effect="blur"
                                                                        placeholderSrc={promotion.image}
                                                                        src={promotion.image}
                                                                        alt={promotion.title}/>
                                                                </a>
                                                                <div
                                                                    className="promo-post__content d-flex flex-row justify-content-between align-items-center">
                                                            <span className="one-line-ellipsis small">
                                                                {promotion.title}
                                                            </span>


                                                                    {
                                                                        promotion?.request_able &&
                                                                        <div
                                                                            className={'d-flex flex-row gap-3 align-items-center'}>
                                                                            <button
                                                                                onClick={e => handleBonusDetail(promotion)}>
                                                                                <SvgIcon id={'info'}/>
                                                                            </button>

                                                                            <span
                                                                                className={`settings__btn small gap-2 ${promotion?.passive ? 'passive' : ''}`}
                                                                                onClick={e => promotion?.passive ? null : handleClaim(promotion)}>
                                                                                    {
                                                                                        redeeming ?
                                                                                            <div
                                                                                                className="loader-logo mini">
                                                                                                <img loading="lazy"
                                                                                                     src={configuration?.icon}
                                                                                                     alt={'logo'}/>

                                                                                            </div> :
                                                                                            <>
                                                                                                <span>{t('bonus-request.button', 'Request')}</span>
                                                                                                <SvgIcon
                                                                                                    id={'get-bonus'}/>
                                                                                            </>
                                                                                    }
                                                                            </span>
                                                                        </div>

                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div
                className="modal fade"
                id="bonus-modal-detail"
                tabIndex={-1}
                onClick={handleCloseDetail}
            >
                <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                    <div className="modal-content bigger">
                        <div className="modal__content bigger">
                            <div className="modal__head">
                                <div className="d-flex align-items-center gap-2">
                                    <SvgIcon id={'wallet'}/>
                                    <h6 className="modal__title">{theBonus?.title}</h6>
                                </div>
                                <button
                                    className="modal__close"
                                    type="button"
                                    onClick={handleCloseDetail}
                                >
                                    <SvgIcon id={'x'}/>
                                </button>
                            </div>

                            {
                                loading ? <Loading/> :
                                    <div className="content">

                                        <div className="content__main content__main--big">

                                            <div className="tournament__cover">
                                                <LazyLoadImage
                                                    height={'100%'}
                                                    width={'100%'}
                                                    effect="blur"
                                                    placeholderSrc={theBonus?.image}
                                                    src={theBonus?.image}
                                                    alt={theBonus?.title}/>
                                            </div>


                                            <div className="article">
                                                <div dangerouslySetInnerHTML={{__html: theBonus?.content}}/>
                                            </div>

                                        </div>
                                    </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        </>


    )

}


export default BonusRequestModal
